// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as I18next$LiveRoom from "../bindings/I18next.bs.js";
import * as Utils_Lot$LiveRoom from "../Utils/Utils_Lot.bs.js";
import * as PropSpread$LiveRoom from "./PropSpread.bs.js";
import * as LotCardImage$LiveRoom from "./LotCardImage.bs.js";
import * as LotCardPrice$LiveRoom from "./LotCardPrice.bs.js";
import * as LotCardTitle$LiveRoom from "./LotCardTitle.bs.js";
import * as LotCardTagline$LiveRoom from "./LotCardTagline.bs.js";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";
import * as StyleConstants$LiveRoom from "../styles/StyleConstants.bs.js";
import * as AnalyticsManager$LiveRoom from "../analytics/AnalyticsManager.bs.js";
import * as LotCardIndicator$LiveRoom from "./LotCardIndicator.bs.js";
import * as SterlingTypography$LiveRoom from "../bindings/SterlingTypography.bs.js";

var liveLotCardClassName = "liveLotCard";

function LotCard$Placeholder(props) {
  var match = Belt_Option.map(props.lotCard.bidState, (function (bidState) {
          return bidState.bidType;
        }));
  var isLive;
  if (match !== undefined && typeof match === "object" && match.NAME === "LiveBidType") {
    var match$1 = match.VAL.liveBidPhase;
    isLive = match$1 === "Live" || match$1 === "ConfirmingResult";
  } else {
    isLive = false;
  }
  return React.createElement("li", {
              className: Curry._1(Css.merge, {
                    hd: Curry._1(Css.style, {
                          hd: Css.height(Css.px(props.lotCardHeight)),
                          tl: /* [] */0
                        }),
                    tl: {
                      hd: isLive ? liveLotCardClassName : "",
                      tl: /* [] */0
                    }
                  })
            }, null);
}

var Placeholder = {
  make: LotCard$Placeholder
};

function LotCard$CardLayout$Image(props) {
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.gridArea({
                          NAME: "ident",
                          VAL: "image"
                        }),
                    tl: {
                      hd: Css.alignSelf("center"),
                      tl: /* [] */0
                    }
                  })
            }, props.children);
}

var $$Image = {
  make: LotCard$CardLayout$Image
};

function LotCard$CardLayout(props) {
  var onClick = props.onClick;
  var banner = props.banner;
  var isLotSelected = props.isLotSelected;
  var faded = props.faded;
  var lotId = props.lotId;
  var faded$1 = faded !== undefined ? faded : false;
  var isLotSelected$1 = isLotSelected !== undefined ? isLotSelected : false;
  var banner$1 = banner !== undefined ? banner : /* Default */8;
  var onClick$1 = onClick !== undefined ? onClick : (function (param) {
        
      });
  var buttonStyle = Curry._1(Css.style, {
        hd: Css.height(Css.px(props.lotCardHeight)),
        tl: {
          hd: Css.textAlign("left"),
          tl: {
            hd: Css.border(Css.px(0), Css.none, "transparent"),
            tl: {
              hd: Css.width(Css.pct(100.0)),
              tl: {
                hd: Css.display(Css.grid),
                tl: {
                  hd: Css.padding4(Css.px(8), Css.px(8), Css.px(8), Css.px(8)),
                  tl: {
                    hd: Css.gridTemplateAreas({
                          NAME: "areas",
                          VAL: ["image . info"]
                        }),
                    tl: {
                      hd: Css.gridTemplateColumns({
                            hd: "auto",
                            tl: {
                              hd: {
                                NAME: "px",
                                VAL: 8
                              },
                              tl: {
                                hd: {
                                  NAME: "minmax",
                                  VAL: [
                                    "zero",
                                    {
                                      NAME: "fr",
                                      VAL: 1.0
                                    }
                                  ]
                                },
                                tl: /* [] */0
                              }
                            }
                          }),
                      tl: {
                        hd: Css.hover({
                              hd: Css.cursor("pointer"),
                              tl: {
                                hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey20_nohashtag)),
                                tl: {
                                  hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                                  tl: /* [] */0
                                }
                              }
                            }),
                        tl: {
                          hd: faded$1 ? Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey80_nohashtag)) : Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                          tl: {
                            hd: isLotSelected$1 ? Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey20_nohashtag)) : Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                            tl: {
                              hd: StyleConstants$LiveRoom.defaultBorder("right", LotCardIndicator$LiveRoom.getIndicatorColor(banner$1), undefined),
                              tl: {
                                hd: Css.position("relative"),
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      });
  return React.createElement(PropSpread$LiveRoom.make, {
              data: {
                hd: {
                  TAG: /* TestId */1,
                  _0: "lotCardId_" + lotId + ""
                },
                tl: /* [] */0
              },
              children: React.createElement("li", {
                    className: props.isLive ? liveLotCardClassName : ""
                  }, React.createElement("button", {
                        "aria-selected": isLotSelected$1,
                        className: buttonStyle,
                        tabIndex: isLotSelected$1 ? 0 : -1,
                        onClick: onClick$1
                      }, React.createElement(LotCard$CardLayout$Image, {
                            children: React.createElement(LotCardImage$LiveRoom.make, {
                                  lotId: lotId,
                                  faded: faded$1
                                })
                          }), React.createElement("div", {
                            className: Curry._1(Css.style, {
                                  hd: Css.gridArea({
                                        NAME: "ident",
                                        VAL: "info"
                                      }),
                                  tl: {
                                    hd: Css.display("grid"),
                                    tl: {
                                      hd: Css.gridTemplateRows({
                                            hd: {
                                              NAME: "minmax",
                                              VAL: [
                                                {
                                                  NAME: "px",
                                                  VAL: 74
                                                },
                                                {
                                                  NAME: "fr",
                                                  VAL: 1.0
                                                }
                                              ]
                                            },
                                            tl: {
                                              hd: "auto",
                                              tl: /* [] */0
                                            }
                                          }),
                                      tl: /* [] */0
                                    }
                                  }
                                })
                          }, props.children), Belt_Option.mapWithDefault(props.flag, null, (function (param) {
                              return React.createElement(LotCardIndicator$LiveRoom.Flag.make, {
                                          flag: param[0],
                                          size: param[1]
                                        });
                            }))))
            });
}

var CardLayout = {
  $$Image: $$Image,
  make: LotCard$CardLayout
};

function LotCard$WithdrawnLot$LotWithdrawnLabel(props) {
  var match = I18next$LiveRoom.useTranslation(undefined);
  return React.createElement(SterlingTypography$LiveRoom.Label12Medium.make, {
              className: Curry._1(Css.style, {
                    hd: Css.textAlign("right"),
                    tl: {
                      hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                      tl: /* [] */0
                    }
                  }),
              children: Curry._1(match.t, "LotListContainer_lotWithdrawn")
            });
}

var LotWithdrawnLabel = {
  make: LotCard$WithdrawnLot$LotWithdrawnLabel
};

function LotCard$WithdrawnLot(props) {
  var onClick = props.onClick;
  var me = props.me;
  var lotId = props.lotId;
  return React.createElement(LotCard$CardLayout, {
              lotId: lotId,
              faded: true,
              isLotSelected: props.isLotSelected,
              isLive: false,
              lotCardHeight: props.lotCardHeight,
              onClick: (function (param) {
                  AnalyticsManager$LiveRoom.auctionRoomInteraction(me, "ClickClosedLot");
                  Curry._1(onClick, lotId);
                }),
              children: React.createElement("div", {
                    className: Curry._1(Css.style, {
                          hd: Css.overflow("hidden"),
                          tl: /* [] */0
                        })
                  }, React.createElement(LotCardTitle$LiveRoom.make, {
                        lotTitle: props.title,
                        subtitle: props.subtitle,
                        lotNumber: props.lotNumber
                      }), React.createElement(LotCard$WithdrawnLot$LotWithdrawnLabel, {}))
            });
}

var WithdrawnLot = {
  LotWithdrawnLabel: LotWithdrawnLabel,
  make: LotCard$WithdrawnLot
};

function LotCard$DefaultCard(props) {
  var lastInParcel = props.lastInParcel;
  var firstInParcel = props.firstInParcel;
  var toggleMobileLotListClick = props.toggleMobileLotListClick;
  var me = props.me;
  var onClick = props.onClick;
  var userBid = props.userBid;
  var bidState = props.bidState;
  var isNoReserve = props.isNoReserve;
  var premiumLotState = props.premiumLotState;
  var lotId = props.lotId;
  var firstInParcel$1 = firstInParcel !== undefined ? firstInParcel : false;
  var lastInParcel$1 = lastInParcel !== undefined ? lastInParcel : false;
  var isClosed = bidState.isClosed;
  var match = bidState.bidType;
  var isLive;
  if (typeof match === "object" && match.NAME === "LiveBidType") {
    var match$1 = match.VAL.liveBidPhase;
    isLive = match$1 === "Live" || match$1 === "ConfirmingResult";
  } else {
    isLive = false;
  }
  var match$2 = bidState.bidType;
  return React.createElement(LotCard$CardLayout, {
              lotId: lotId,
              faded: isClosed,
              isLotSelected: props.isLotSelected,
              isLive: isLive,
              lotCardHeight: props.lotCardHeight,
              banner: LotCardIndicator$LiveRoom.getBanner(premiumLotState.isPremium, Belt_Option.isSome(props.parcel), isNoReserve),
              flag: LotCardIndicator$LiveRoom.getFlag(userBid, premiumLotState.isPremium, isNoReserve, firstInParcel$1, lastInParcel$1),
              onClick: (function (param) {
                  AnalyticsManager$LiveRoom.auctionRoomInteraction(me, isClosed ? (
                          isLive ? "ClickUpcomingLot" : "ClickClosedLot"
                        ) : (
                          isLive ? "ClickCurrentLot" : "ClickUpcomingLot"
                        ));
                  Curry._1(onClick, lotId);
                  Curry._1(toggleMobileLotListClick, false);
                }),
              children: null
            }, React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.overflow(Css.hidden),
                        tl: /* [] */0
                      })
                }, React.createElement(LotCardTagline$LiveRoom.make, {
                      isPremium: premiumLotState.isPremium,
                      userBid: userBid,
                      bidPhase: typeof match$2 === "object" && match$2.NAME === "LiveBidType" ? match$2.VAL.liveBidPhase : undefined,
                      sold: bidState.sold
                    }), React.createElement(LotCardTitle$LiveRoom.make, {
                      lotTitle: props.title,
                      subtitle: props.subtitle,
                      creators: props.creators,
                      lotNumber: props.lotNumber
                    })), React.createElement("div", undefined, React.createElement(LotCardPrice$LiveRoom.make, {
                      bidState: bidState,
                      fallback: Caml_option.some(React.createElement(LotCardPrice$LiveRoom.Estimate.make, {
                                estimate: props.estimate,
                                isLotClosed: bidState.isClosed
                              }))
                    })));
}

var DefaultCard = {
  make: LotCard$DefaultCard
};

var fallbackBidState = {
  __typename: "BidState",
  id: "BidStateId",
  isClosed: true,
  bidType: {
    NAME: "LiveBidType",
    VAL: {
      __typename: "LiveBidType",
      liveBidPhase: "Closed",
      bidMethod: "Advanced"
    }
  },
  currentBid: undefined,
  startingBid: undefined,
  sold: undefined
};

var fallbackEstimate = {
  NAME: "EstimateUponRequest",
  VAL: {
    __typename: "EstimateUponRequest",
    estimateUponRequest: true
  }
};

function LotCard(props) {
  var lotCard = props.lotCard;
  var withdrawnState = lotCard.withdrawnState;
  var latestBid = lotCard.latestBid;
  var lotNumber = lotCard.lotNumber;
  var creatorsDisplayNames = lotCard.creatorsDisplayNames;
  var subtitle = lotCard.subtitle;
  var title = lotCard.title;
  var lotId = lotCard.lotId;
  var me = props.me;
  var lotCardHeight = props.lotCardHeight;
  var onClick = props.onClick;
  var estimate = Belt_Option.getWithDefault(lotCard.estimate, fallbackEstimate);
  var creators = props.showLotCreators && Caml_obj.notequal(creatorsDisplayNames, []) ? creatorsDisplayNames : undefined;
  var bidState = Belt_Option.getWithDefault(lotCard.bidState, fallbackBidState);
  var isLotSelected = props.selectedLotId === lotId;
  if (withdrawnState.state === "Withdrawn" && Belt_Option.isSome(latestBid.bid)) {
    return React.createElement(LotCard$WithdrawnLot, {
                lotId: lotId,
                title: title,
                subtitle: subtitle,
                lotNumber: lotNumber,
                isLotSelected: isLotSelected,
                me: me,
                onClick: onClick,
                lotCardHeight: lotCardHeight
              });
  } else if (withdrawnState.state === "Withdrawn") {
    return null;
  } else {
    return React.createElement(LotCard$DefaultCard, {
                lotId: lotId,
                title: title,
                subtitle: subtitle,
                creators: creators,
                lotNumber: lotNumber,
                estimate: estimate,
                premiumLotState: lotCard.premiumLotState,
                parcel: lotCard.parcel,
                isNoReserve: Belt_Array.some(Utils_Lot$LiveRoom.getTags(Belt_Option.getWithDefault(lotCard.lotTags, []), undefined), (function (tag) {
                        return Caml_obj.equal(tag, /* NoReserve */0);
                      })),
                bidState: bidState,
                userBid: latestBid.bid,
                isLotSelected: isLotSelected,
                onClick: onClick,
                lotCardHeight: lotCardHeight,
                me: me,
                toggleMobileLotListClick: props.toggleMobileLotListClick,
                firstInParcel: props.firstInParcel,
                lastInParcel: props.lastInParcel
              });
  }
}

var LatestUserBid;

var LotCardFragment;

var BidStateFragment;

var PremiumLotStateFragment;

var defaultLotCardHeight = 112;

var lotCardHeightWithCurrency = 130;

var make = LotCard;

export {
  LatestUserBid ,
  LotCardFragment ,
  BidStateFragment ,
  PremiumLotStateFragment ,
  liveLotCardClassName ,
  defaultLotCardHeight ,
  lotCardHeightWithCurrency ,
  Placeholder ,
  CardLayout ,
  WithdrawnLot ,
  DefaultCard ,
  fallbackBidState ,
  fallbackEstimate ,
  make ,
}
/* Css Not a pure module */
